/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { HttpResponse, delay, http } from 'msw';

export const getPostApiJsApPayeesInvitationsMailsMock = () => ({
  message: 'Mail successfully sent',
});

export const handlers = [
  http.post('*/api/js/ap_payees/invitations/mails', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getPostApiJsApPayeesInvitationsMailsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
];
